<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="row g-1">

            <!-- Message Security -->
            <div class="col-md-12 text-success">
                <div class="alert alert-success">
                    <div>
                        <img src="/img/pagarme.svg" class="mx-auto" alt="" height="55px" />
                    </div>
                    <div class="mt-3">
                        <span class="fas fa-lock mr-1"></span>
                        Esta página utiliza criptografia 256 bits para garantir a segurança dos seus dados de pagamento.
                    </div>
                </div>
            </div>

            <!-- Holder Name -->
            <div class="col-md-12">
                <b-form-group label="Nome">
                    <b-form-input
                        type="text"
                        name="holder-name"
                        v-model="form.holder_name"
                        placeholder="Insira o nome do titular do cartão"
                        required
                    />
                </b-form-group>
            </div>

            <!-- Card Number -->
            <div class="col-md-12">
                <b-form-group label="Número do Cartão">
                    <b-input-group>
                        <b-form-input
                            type="tel"
                            name="card-number"
                            v-model="form.number"
                            v-mask="'#### #### #### ####'"
                            placeholder="#### #### #### ####"
                            required
                            :state="hasErrors('request.card.number', errors)"
                        />
                        <template #append>
                            <b-input-group-text v-if="brand"><strong class="text-capitalize" >{{ brand }}</strong></b-input-group-text>
                        </template>

                    </b-input-group>
                </b-form-group>
                <!-- Error -->
                <has-errors :errors="errors" name='request.card.number' />
            </div>

            <!-- Card Exp Month -->
            <div class="col-md-6">
                <b-form-group label="Mês de Expiração">
                    <b-form-select
                        name="card-exp-month"
                        v-model="form.exp_month"
                        :options="monthsOptions"
                        required>
                    </b-form-select>
                </b-form-group>
            </div>

            <!-- Card Exp Year -->
            <div class="col-md-6">
                <b-form-group label="Ano de Expiração">
                    <b-form-select
                        name="card-exp-year"
                        v-model="form.exp_year"
                        :options="yearsOptions"
                        required>
                    </b-form-select>
                </b-form-group>
            </div>

            <!-- CVV -->
            <div class="col-md-12">
                <b-form-group label="Código de Segurança">
                    <b-form-input
                        type="tel"
                        name="cvv"
                        v-model="form.cvv"
                        placeholder="Insira o código de segurança do seu cartão"
                        v-mask="['###', '####']"
                        required
                    />
                </b-form-group>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import cardValidations from '../cards/mixins/cardValidations';
export default {
    mixins: [cardValidations],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                holder_name: null,
                number: null,
                exp_month: null,
                exp_year: null,
                cvv: null,
            },
            brand: null,
            yearsOptions: this.generateYearsOptions(),
            monthsOptions: [
                { value: 1, text: 'Janeiro - 01' },
                { value: 2, text: 'Fevereiro - 02' },
                { value: 3, text: 'Março - 03' },
                { value: 4, text: 'Abril - 04' },
                { value: 5, text: 'Maio - 05' },
                { value: 6, text: 'Junho - 06' },
                { value: 7, text: 'Julho - 07' },
                { value: 8, text: 'Agosto - 08' },
                { value: 9, text: 'Setembro - 09' },
                { value: 10, text: 'Outubro - 10' },
                { value: 11, text: 'Novembro - 11' },
                { value: 12, text: 'Dezembro - 12' },
            ]
        }
    },
    watch: {
        form: {
            handler: function (value) {
                this.$emit('update', value)
            },
            deep: true
        },
        'form.number'() {

            this.errors = {};
            if(this.form.number.length > 13){
                if(! this.isValidCardNumber(this.form.number)){
                    this.errors = { 'request.card.number': ['Número de cartão inválido']}
                }
                this.brand = this.getBrand(this.form.number);
            }
        }
    },
    created() {
        //
    },
    methods: {
        generateYearsOptions() {
            const currentYear = new Date().getFullYear();
            const years = 20;
            const yearsOptions = [];

            for (let i = 0; i < years; i++) {
                yearsOptions.push(currentYear + i);
            }

            return yearsOptions;
        },
    }
}
</script>

<style scoped>

</style>
